// Professional work highlights — showcases systems built, not employers.
export const highlights = [
  {
    featured: true,
    ownership: "Built end-to-end · solo",
    title: "Interview Screen Recording & Resumable Chunked Upload",
    domain: "AI interview platform · high-volume video recordings",
    built: [
      "Designed and built an in-house replacement for a paid third-party recording service, removing the vendor dependency for interview recordings.",
      "Frontend (React): in-browser screen recording of live interview sessions, splitting the stream into chunks while recording is still in progress.",
      "Backend (Node.js/Express): chunk upload APIs that track every part, so an interrupted upload resumes exactly where it stopped instead of starting over.",
      "Storage: chunks streamed to cloud object storage (GCP Cloud Storage / AWS S3) and assembled into the final recording.",
      "Per-chunk retry so a single failed part is re-sent on its own — candidates on unstable networks never lose their interview.",
    ],
    impact: [
      "Replaced a paid third-party recording service",
      "Owned frontend → backend → storage",
      "Resumes after network drops",
    ],
    tech: ["React", "Node.js", "Express", "GCP Cloud Storage", "AWS S3", "MongoDB"],
  },
  {
    title: "Interview Lifecycle APIs & Query Optimization",
    domain: "Interview-tech platform · core backend",
    built: [
      "REST APIs covering onboarding → evaluation → verdict, with role-based access control for candidates, interviewers, and admins.",
      "Compound indexes and aggregation pipelines for heavy reporting queries; Redis caching for hot interview/session data.",
      "Reusable middleware and React/Redux component library shared across features.",
    ],
    impact: ["40–60% faster queries", "~25% faster feature delivery"],
    tech: ["Node.js", "Express", "MongoDB", "Redis", "Redux Toolkit"],
  },
  {
    title: "Live Session Reliability & CI/CD",
    domain: "Real-time interviews · DevOps",
    built: [
      "WebSocket retry and reconnection policies that keep live interview sessions alive through brief disconnects.",
      "Contributed to Docker image and CI/CD pipeline optimizations for faster, lighter deployments.",
    ],
    impact: ["~60% smaller Docker images", "~55% faster CI/CD builds"],
    tech: ["WebSockets", "Socket.IO", "Docker", "CI/CD"],
  },
  {
    title: "AI-Driven Async Video Interview Platform",
    domain: "AI interview product · microservices",
    built: [
      "Node.js/Express microservices for scheduling, dynamic question flows, and automated scoring logic with RBAC.",
      "Refactored React/Redux dashboard modules for faster loads and smoother interactions.",
    ],
    impact: ["1,000+ interviews / month", "20–30% faster dashboards"],
    tech: ["Node.js", "Express", "Microservices", "React", "Redux"],
  },
  {
    title: "Hotel Management SaaS + Smart-Room IoT",
    domain: "Hospitality SaaS · built from scratch",
    built: [
      "Booking engine, front desk, room management, and admin modules for a 100+ room property.",
      "Event-driven IoT integration via Tuya APIs and webhooks — lighting, thermostat, presence sensors and more, with real-time device state sync.",
      "Firebase-powered live dashboards, secure auth flows, code splitting and lazy loading.",
    ],
    impact: ["100+ rooms in production", "4+ IoT device types"],
    tech: ["React", "Node.js", "MongoDB", "Tuya APIs", "Webhooks", "Firebase"],
    liveUrl: "https://shashihotel.com",
  },
];
